<script>
	import OffsetWrapper from './OffsetWrapper.svelte';

	export let device;
</script>

<OffsetWrapper {device} setting={'temperature'} />
